import { connect } from 'react-redux';

import { getActiveTaskId, getTaskAddedByCopy } from '../../../../selectors/checklist/checklistSelectors';
import * as checklistV2Actions from '../../../../actions/ChecklistV2Actions';

import ChecklistTaskItem from './ChecklistTaskItem';

const mapStateToProps = (state, ownProps) => ({
  selectedTaskId: getActiveTaskId(state),
  addedByName: getTaskAddedByCopy(state, ownProps.taskId, ownProps.addedByUserId),
});

const mapDispatchToProps = dispatch => ({
  goToTask: taskId => dispatch(checklistV2Actions.goToChecklistTask(taskId)),
  completeTask: taskId => dispatch(checklistV2Actions.toggleCompleted(taskId))
    .then(json => dispatch(checklistV2Actions.emitConfMsg(json.payload.task.completed_at))),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChecklistTaskItem);



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistTaskItem/index.js